import React from 'react';
import PipelineProgressSection from '../../section/PipelineProgress/PipelineProgress.section';

const PipelineProgressPage: React.FC = () => <PipelineProgressSection />;

export default PipelineProgressPage;
